import {reduxForm} from 'redux-form';
import PartnerBannerForm from './PartnerBannerForm';
import {load, save, create, update, updateUrl, updateLinkType, updateBannerPromoLink, deleteBanner} from '../../../actions/partnerBanner';
import getProperModules from '../../../reducers/modules-config/modulesGetter';

const fields = ['registration', 'main', 'news', 'fan_box', 'about_us', 'engage', 'fan_pit', 'fan_feed',
  'wayfinder', 'stream', 'shop', 'vip', 'settings'];

export default reduxForm({
    form: 'PartnerBannerForm',
    fields
  },
  ({auth: {user}, banner: {bannerList, loading}}) => ({
    club_id: user.club.id,
    modules: getProperModules(user.club.id, user.club.modules, ((m)=>(m.isOnBannerTable))),
    bannerList,
    loading,
    initialValues: initialCheckedRadioButtons(bannerList)
  }),
  (dispatch) => ({
    load: (club_id) => dispatch(load(club_id)),
    save: (bannerList, banners, club_id) => dispatch(save(bannerList, banners, club_id)),
    create: (image, club_id) => dispatch(create(image, club_id)),
    update: (image, key, banner, club_id) => dispatch(update(image, key, banner, club_id)),
    updateUrl: (url, key) => dispatch(updateUrl(url, key)),
    updateLinkType: (linkType, key) => dispatch(updateLinkType(linkType, key)),
    updateBannerPromoLink: (key, banner, product) => dispatch(updateBannerPromoLink(key, banner, product)),
    deleteBanner: (key, id, club_id) => dispatch(deleteBanner(key, id, club_id))
  })
)(PartnerBannerForm);

function initialCheckedRadioButtons(bannerList) {
  let positions = {};
  bannerList.forEach((banner, key)=> {
    banner.modules.forEach((module)=> {
      positions[module] = bannerList[key];
    });
  });

  if (Object.keys(positions).length !== fields.length) {
    let defaultValues = arr_diff(Object.keys(positions), fields);
    defaultValues.forEach((value)=> {
      positions[value] = 'empty';
    });
  }

  return {...positions}
}

function arr_diff(a1, a2) {
  var a = [];
  var diff = [];
  for (var i = 0; i < a1.length; i++) {
    a[a1[i]] = true;
  }
  for (var i = 0; i < a2.length; i++) {
    if (a[a2[i]]) {
      delete a[a2[i]];
    } else {
      a[a2[i]] = true;
    }
  }
  for (var k in a) {
    diff.push(k);
  }
  return diff;
}



// WEBPACK FOOTER //
// ./src/components/Partner/PartnerBannerForm/index.js